<template>
  <div role="listbox" ref="dropdown" :style="{width}" :class="['bcq-clustered-list-2', 'select-none', `bcq-clustered-list-2-${dropdownDirection}`, `text-${dense ? 'xs' : 'sm'}`, internalDisabled ? ['pointer-events-none', 'opacity-50'] : null, !disabled && resource.length ? null : ['pointer-events-none', 'opacity-50']]">
    <text-field-label :text="label" :color="$dark ? 'white' : 'black'" v-if="label" />
    <table-layout equal-cells :class="['bcq-clustered-header-outer-wrapper']">
      <row v-if="!expanded">
        <cell @click.native="hidden = !hidden" :class="['cursor-pointer']" y-align="middle">
          <div :class="['bcq-clustered-list-2-header']" :title="header">
            <table-layout equal-cells y-align="middle">
              <row>
                <cell v-if="icon" :class="['bcq-clustered-list-2-items-item-icon']" x-align="center">
                  <icon :provider="iconProvider" :color="selection.length || !hidden ? color : null" :color-lightness="colorLightness" :name="icon" />
                </cell>
                <cell>
                  <div :class="['truncate', icon ? dense ? ['pr-1'] : null : 'px-1', selection.length ? `text-${color}${color === 'bcq' ? '' : '-' + colorLightness}` : 'opacity-50']" v-html="header" />
                </cell>
                <cell :class="['bcq-clustered-list-2-items-item-icon', dense ? 'px-1' : 'px-2']" x-align="right">
                  <icon :name="hidden ? 'chevron-down' : 'chevron-up'" :color="selection.length || !hidden ? color : $dark ? 'white' : 'black'" :color-lightness="selection.length || !hidden ? colorLightness : null" :class="['cursor-pointer']" />
                </cell>
              </row>
            </table-layout>
            <line-ripple :visible="false" :bg-color="selection.length || !hidden ? color : $dark ? 'white' : 'black'" :bg-color-lightness="selection.length || !hidden ? colorLightness : null" />
          </div>
        </cell>
        <cell v-if="toggleSelectionBtn && multiple" x-align="center" :class="['bcq-clustered-list-2-items-item-icon', dense ? ['px-1', 'pt-1'] : 'px-2']" y-align="top">
          <icon @click="toggleSelection" :name="toggleSelectionIcon" :color="selection.length || !hidden ? color : null" :color-lightness="colorLightness" :class="['cursor-pointer']" />
        </cell>
      </row>
      <row>
        <cell :class="['relative']">
          <card :class="['bcq-clustered-list-2-dropdown', expanded ? null : 'absolute', 'transition-all', 'duration-500', 'w-full', hidden && !expanded ? ['clip-0', 'opacity-0'] : null]" :style="{zIndex: itemsZIndex}">
            <card-text padding-off :class="[dense ? 'px-1' : 'px-2', 'mb-1']" v-if="searchable">
              <text-field clearable v-model="search" :color="color" :placeholder="searchLabel" :color-lightness="colorLightness" />
            </card-text>
            <card-text padding-off :class="[dense ? 'px-1' : 'px-2']">
              <recycle-scroller :key-field="valueKey" v-slot="{item}" :style="{height: itemHeight * visibleItems + 'px'}" :items="filtered" :item-size="itemHeight" :class="['bcq-clustered-list-2-items']">
                <div v-ripple @click="toggleItem(item)" :class="['bcq-clustered-list-2-items-item', 'transition-all', 'duration-500', 'cursor-pointer', selection.includes(item[valueKey]) && !multiple ? ['pointer-events-none'] : null, selection.includes(item[valueKey]) ? 'bcq-clustered-list-2-items-item-selected' : null]" :style="{lineHeight: `${itemHeight}px`}">
                  <table-layout y-align="middle" equal-cells>
                    <row :title="item[labelKey]">
                      <cell :class="['bcq-clustered-list-2-items-item-icon', 'px-1']" x-align="center" v-if="multiple">
                        <icon :color="color" :color-lightness="colorLightness" :name="selection.includes(item[valueKey]) ? 'checkbox-marked' : 'checkbox-blank-outline'" />
                      </cell>
                      <cell :class="['px-1', 'w-full', 'bcq-clustered-list-2-items-item-label', 'w-full']">
                        <div v-html="item[labelKey]" :class="['truncate']" />
                      </cell>
                    </row>
                  </table-layout>
                </div>
              </recycle-scroller>
            </card-text>
            <card-actions v-if="applyBtn && multiple" padding-off :class="['p-1']">
              <divider :class="['mb-1']" />
              <table-layout equal-cells y-align="middle">
                <row>
                  <cell :class="['text-xs', 'truncate']" v-if="showDetails" v-html="details" />
                  <cell x-align="right" :class="['whitespace-nowrap']">
                    <icon v-if="expanded && toggleSelectionBtn && multiple" @click="toggleSelection" :provider="iconProvider" :name="toggleSelectionIcon" :color="color" :color-lightness="colorLightness" :class="['cursor-pointer', 'mr-1']" /><!--
                    --><btn v-if="multiple" plain @click="apply" size="xs" :color="color" :title="applyBtnLabel" :color-lightness="colorLightness">{{ applyBtnLabel }}</btn>
                  </cell>
                </row>
              </table-layout>
            </card-actions>
          </card>
        </cell>
        <cell v-if="toggleSelectionBtn && !expanded && multiple" />
      </row>
      <row v-if="showSelectionTypeLabel && multiple">
        <cell>
          <container v-html="selectionTypeLabel" v-if="showSelectionTypeLabel" :class="['text-right', 'text-xs', 'py-1']" />
        </cell>
        <cell v-if="toggleSelectionBtn && !expanded && multiple" />
      </row>
    </table-layout>
    <script type="text/js-worker" :data-worker-id="name">
    onmessage = ($event) => {
      const data = $event.data
      postMessage(data.items.map(item => {
        return item[data.valueKey]
      }))
    }
    </script>
  </div>
</template>
<script>
export default {
  name: 'ClusteredList2',
  data () {
    return {
      search: '',
      selection: [],
      hidden: true,
      dropdownDirection: 'down',
      internalDisabled: false
    }
  },
  model: {
    prop: 'defaultSelection',
    event: 'input'
  },
  props: {
    multiple: {
      type: Boolean
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    searchLabel: {
      type: String,
      default: 'Filter items...'
    },
    dense: {
      type: Boolean
    },
    selectItemsLabel: {
      type: String,
      default: 'Select items...'
    },
    itemsZIndex: {
      type: Number,
      default: 900
    },
    fuzzySearch: {
      type: Boolean
    },
    itemHeight: {
      type: Number,
      default: 32
    },
    icon: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    label: {
      type: String
    },
    visibleItems: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean
    },
    resource: {
      type: Array,
      default () {
        return {
          data: [] // [{text: String, value: String}]
        }
      }
    },
    color: {
      type: String,
      default: 'red'
    },
    colorLightness: {
      type: Number,
      default: 500
    },
    applyBtn: {
      type: Boolean,
      default: true
    },
    applyBtnLabel: {
      type: String,
      default: 'Apply'
    },
    name: {
      type: String,
      required: true
    },
    toggleSelectionBtn: {
      type: Boolean,
      default: true
    },
    toggleSelectionIcon: {
      type: String,
      default: 'select-all'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    defaultSelection: {
      type: [
        String,
        Array
      ]
    },
    expanded: {
      type: Boolean
    },
    width: {
      type: String
    },
    showSelectionTypeLabel: {
      type: Boolean,
      default: true
    },
    labelKey: {
      type: [String, Number],
      default: 'text'
    },
    valueKey: {
      type: [String, Number],
      default: 'value'
    },
    useWorker: {
      type: Boolean
    },
    headerItems: {
      type: Number,
      default: 10
    },
    sort: {
      type: Object,
      default () {
        return {
          descending: false
        }
      }
    },
    selectionTypeLabelDict: {
      type: Object,
      default () {
        return {
          all: 'all',
          none: 'none',
          some: 'some',
          label (type, color, colorLightness) {
            return `<span class="opacity-50">selected</span>: <span class="font-semibold text-${color}${colorLightness ? '-' + colorLightness : ''}">${type}</span>`
          }
        }
      }
    }
  },
  watch: {
    hidden () {
      const hidden = this.hidden
      const searchable = this.searchable
      const body = document.querySelector('body')
      const iframeBlocker = 'iframe-blocker'
      if (!hidden) {
        const dropdown = this.$el
        if (searchable) {
          dropdown.querySelector('.bcq-text-field input').focus()
        }
        if (!this.expanded) {
          const boundingRect = dropdown.getBoundingClientRect()
          const offsetTop = boundingRect.y
          const viewportHeight = document.documentElement.clientHeight
          const itemHeight = this.itemHeight * this.visibleItems
          const searchableHeight = this.searchable ? 40 : 0
          if (Math.ceil(itemHeight + offsetTop + searchableHeight + 90) > Math.floor(viewportHeight)) {
            this.dropdownDirection = 'up'
          } else {
            this.dropdownDirection = 'down'
          }
        }
      }
      hidden ? body.classList.remove(iframeBlocker) : body.classList.add(iframeBlocker)
    },
    resource () {
      this.reset()
    }
  },
  mounted () {
    this.reset()
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  computed: {
    selectionTypeLabel () {
      if (this.showSelectionTypeLabel) {
        const selection = this.selection.length
        const items = this.resource.length
        const selectionTypeLabelDict = this.selectionTypeLabelDict
        let type = selectionTypeLabelDict.all
        if (selection === 0) {
          type = selectionTypeLabelDict.none
        } else if (selection < items) {
          type = selectionTypeLabelDict.some
        }
        return selectionTypeLabelDict.label(type, this.selection.length ? this.color : this.$dark ? 'white' : 'black', this.selection.length ? this.colorLightness : null)
      }
    },
    details () {
      return `${this.selection.length}/${this.resource.length}`
    },
    header () {
      let items = []
      const selection = this.selection
      const resource = this.resource
      const headerItems = this.headerItems
      const valueKey = this.valueKey
      const labelKey = this.labelKey
      if (selection.length === resource.length) {
        items = resource.slice(0, headerItems).map(item => {
          return item[labelKey]
        }).sort()
      } else if (selection.length < resource.length && selection.length) {
        items = resource.filter(item => selection.includes(item[valueKey])).slice(0, headerItems).map(item => {
          return item[labelKey]
        }).sort()
      }
      return items.length ? items.join(', ') : this.selectItemsLabel
    },
    filtered () {
      const sort = this.sort
      const labelKey = this.labelKey
      if (this.searchable) {
        const search = this.search.toLowerCase()
        const data = this.resource.filter(item => {
          if (item) {
            const text = item[labelKey].toString().toLowerCase()
            if (this.fuzzySearch ? text.indexOf(search) > -1 : text.substring(0, search.length) === search) {
              return item
            }
          }
        })
        return data.sort(this.sortItems(labelKey, sort.descending))
      } else {
        return this.resource.map(item => {
          return item
        }).sort(this.sortItems(labelKey, sort.descending))
      }
    }
  },
  methods: {
    reset () {
      this.selection = []
      this.setDefaultSelection()
    },
    sortItems (key, descending = false) {
      /* usage: Array.sort(sortItems(key, descending)) */
      return function (a, b) {
        if (a[key].toString().toLowerCase() > b[key].toString().toLowerCase()) {
          return descending ? -1 : 1
        }
        if (a[key].toString().toLowerCase() < b[key].toString().toLowerCase()) {
          return descending ? 1 : -1
        }
        return 0
      }
    },
    setDefaultSelection () {
      const defaultSelection = this.defaultSelection
      const valueKey = this.valueKey
      if (defaultSelection === 'all') {
        this.selectAll(false)
      } else if (typeof defaultSelection === 'object' && defaultSelection.length) {
        this.selection = this.resource.filter(item => defaultSelection.includes(item[valueKey])).map(item => {
          return item[valueKey]
        })
      }
    },
    selectAll (apply = true) {
      if (this.useWorker) {
        this.internalDisabled = true
        const blob = new Blob(Array.prototype.map.call(
          this.$el.querySelectorAll(`[data-worker-id="${this.name}"]`),
          (script) => script.textContent,
          {
            type: 'text/javascript'
          }
        ))
        const worker = new Worker(window.URL.createObjectURL(blob))
        // const worker = new Worker('/static/workers/clustered-list.js')
        worker.postMessage({items: this.resource, valueKey: this.valueKey})
        worker.onmessage = ($event) => {
          this.selection = $event.data
          this.internalDisabled = false
          worker.terminate()
          if (apply) {
            this.apply()
          }
        }
      } else {
        this.selection = this.resource.map(item => {
          return item[this.valueKey]
        })
      }
    },
    toggleItem (item) {
      const id = item[this.valueKey]
      const selection = this.selection
      if (this.multiple) {
        if (selection.includes(id)) {
          const index = selection.findIndex(item => item === id)
          selection.splice(index, 1)
        } else {
          selection.push(id)
        }
        this.selection.sort()
        this.$emit('input', this.selection)
      } else {
        this.selection = [item[this.valueKey]]
        this.apply()
      }
    },
    apply () {
      const selection = this.selection
      this.$emit('apply', {
        name: this.name,
        items: selection,
        length: selection.length,
        size: this.resource.length
      })
      this.hidden = true
      this.$emit('input', this.selection)
    },
    toggleSelection () {
      if (this.selection.length) {
        this.selection = []
        this.apply()
      } else {
        this.selectAll()
      }
    },
    documentClick (e) {
      let el = this.$refs['dropdown']
      let target = e.target
      if (el !== target && !el.contains(target)) {
        this.hidden = true
      }
    }
  }
}
</script>
<style>
.bcq-clustered-list-2 .bcq-clustered-list-2-items-item-icon
{
  width: 32px;
}

.bcq-clustered-list-2 .bcq-clustered-list-2-header .truncate
{
  width: 100%;
  line-height: 25px;
}

.bcq-clustered-list-2 .bcq-clustered-list-2-items-item:hover,
.bcq-clustered-list-2 .bcq-clustered-list-2-items-item-selected
{
  background: var(--router-link-active);
}

.bcq-ui-theme-dark .bcq-clustered-list-2 .bcq-clustered-list-2-items-item:hover,
.bcq-ui-theme-dark .bcq-clustered-list-2 .bcq-clustered-list-2-items-item-selected
{
  background: var(--router-link-active-dark);
}
</style>
<style>
.bcq-clustered-list-2.bcq-clustered-list-2-up .bcq-clustered-list-2-dropdown
{
  bottom: 28px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/clustered-list-2/clustered-list-2.vue